import React from 'react';
import { Button, Typography } from '@icecreamsocial/components';
import { Link, useHistory } from 'react-router-dom';
import { OfferHint, PageWrapper } from '../../../../presentational';
import { usePostMessage, useStore } from '../../../../hooks';
import { useIntl } from 'react-intl';

export const ThankYou = ({ ...rest }) => {
	/**
	 * init hooks
	 */
	const intl = useIntl();
	const { origin } = useStore();
	const dispatchMessage = usePostMessage();

	/**
	 * translation strings
	 */
	const THANKS_TITLE = intl.formatMessage({
		id: 'thankyou.heading',
		defaultMessage: 'Thanks for sharing!',
		description: 'Heading on thank you page after a user has shared',
	});

	const THANKS_MESSAGE = intl.formatMessage({
		id: 'thankyou.message',
		defaultMessage:
			"You're a champ! We'll send you updates on your reward progress to your inbox.",
		description:
			'Message that appears on thank you page that compliments the user for sharing and tells them next steps',
	});

	const THANKS_REMINDER = intl.formatMessage({
		id: 'thankyou.reminder',
		defaultMessage:
			'Keep in mind you can always revisit this offer later if you want to continue sharing.',
		description:
			'Message that appears under the thank you message that reminds the user that they can view the offer later to share again',
	});

	const SHARE_CTA = intl.formatMessage({
		id: 'thankyou.shareCTA',
		defaultMessage: 'Continue Sharing',
		description:
			'Call to action text on a button to encourage users to share more',
	});

	const DISMISS_CTA = intl.formatMessage({
		id: 'thankyou.dismissCTA',
		defaultMessage: 'Dismiss',
		description:
			'Call to action text on a button that allows the user to close the widget',
	});

	return (
		<PageWrapper>
			<Typography.H1 textAlign='center'>{THANKS_TITLE}</Typography.H1>
			<Typography.P>{THANKS_MESSAGE}</Typography.P>
			<Typography.P>{THANKS_REMINDER}</Typography.P>
			<OfferHint />
			<Button
				as={Link}
				to='/share'
				backgroundColor='accent'
				textColor='bodyInverse'
				textAlign='center'
				textDecoration='none'
				elWidth='100%'
				padding='16px 32px'
			>
				{SHARE_CTA}
			</Button>
			<Typography.Span
				as={Button}
				onClick={() =>
					dispatchMessage(
						{
							type: 'ics_dismiss',
							sender: window.origin,
						},
						origin
					)
				}
				border='none'
				shadow='none'
				hoverShadow='none'
				backgroundColor='transparent'
				textAlign='center'
				textDecoration='underline'
				elWidth='100%'
				padding='16px 32px'
				marginTop='md'
			>
				{DISMISS_CTA}
			</Typography.Span>
		</PageWrapper>
	);
};
